import { render, staticRenderFns } from "./choose_us.vue?vue&type=template&id=4370193a&scoped=true"
import script from "./choose_us.vue?vue&type=script&lang=js"
export * from "./choose_us.vue?vue&type=script&lang=js"
import style0 from "./choose_us.vue?vue&type=style&index=0&id=4370193a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370193a",
  null
  
)

export default component.exports